var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { allFilters } from './../components/bounties/bounties-filters/bounties-filters.component';
import { BountyService } from './../services/bounty.service';
import { WindowService } from '../services/window.service';
export var sortableFields = [
    { label: 'Date (Newest)', value: 'id,desc' },
    { label: 'Date (Oldest)', value: 'id,asc' },
    { label: 'Ending Soonest', value: 'ends_at,asc' },
    { label: 'Reward (Highest)', value: 'reward,desc' },
    { label: 'Reward (Lowest)', value: 'reward,asc' },
    { label: 'Popular (Most)', value: 'likes,desc' },
    { label: 'Popular (Least)', value: 'likes,asc' },
];
var BountiesResolver = /** @class */ (function () {
    function BountiesResolver(bountyService, windowService) {
        this.bountyService = bountyService;
        this.windowService = windowService;
    }
    BountiesResolver.prototype.resolve = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tab, sort, filters, search, allTabs, appliedTab, appliedSort, appliedFilters, appData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = state.queryParams, tab = _a.tab, sort = _a.sort, filters = _a.filters, search = _a.search;
                        allTabs = ['active', 'completed', 'liked'];
                        appliedTab = allTabs.includes(tab) ? tab : allTabs[0];
                        appliedSort = sortableFields.map(function (f) { return f.value; }).includes(sort)
                            ? sort
                            : sortableFields[0].value;
                        appliedFilters = filters
                            ? filters.split(',').filter(function (val) { return allFilters.includes(val); })
                            : [];
                        return [4 /*yield*/, this.getAppData({
                                appliedFilters: appliedFilters,
                                appliedTab: appliedTab,
                                appliedSort: appliedSort,
                                search: search,
                            })];
                    case 1:
                        appData = _b.sent();
                        return [2 /*return*/, {
                                listResults: appData,
                                appliedFilters: appliedFilters,
                                appliedSort: appliedSort,
                                appliedTab: appliedTab,
                                search: search,
                            }];
                }
            });
        });
    };
    BountiesResolver.prototype.getAppData = function (_a) {
        var appliedFilters = _a.appliedFilters, appliedSort = _a.appliedSort, appliedTab = _a.appliedTab, search = _a.search;
        return __awaiter(this, void 0, void 0, function () {
            var preRenderedData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        preRenderedData = this.windowService.appData;
                        if (preRenderedData) {
                            // On first page load, return global data
                            return [2 /*return*/, preRenderedData];
                        }
                        return [4 /*yield*/, this.bountyService.list({
                                filters: appliedFilters,
                                sort: appliedSort,
                                tab: appliedTab,
                                search: search,
                                page: 1,
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return BountiesResolver;
}());
export { BountiesResolver };
